import { render, staticRenderFns } from "./CustomerLevelDetail.vue?vue&type=template&id=0b631673&"
import script from "./CustomerLevelDetail.vue?vue&type=script&lang=js&"
export * from "./CustomerLevelDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../nguonhangchina/admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports